// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"68861993","453":"32734b96","484":"804a1752","634":"1bebd3af","688":"438f1132","738":"6e937c03"}[chunkId] + ".chunk.js";
};